import type { ReactNode } from "react";

export interface EmptyStateProps {
  message: ReactNode;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

/**
 * Generic empty state. Optionally renders a primary-button CTA.
 * Mirrors the `.empty-state` markup from the legacy templates.
 */
export default function EmptyState({ message, ctaLabel, onCtaClick }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <p>{message}</p>
      {ctaLabel && onCtaClick ? (
        <button type="button" className="button button--primary" onClick={onCtaClick}>
          {ctaLabel}
        </button>
      ) : null}
    </div>
  );
}
